import { ROUND_LABELS, type RoundReached, type Team } from "./types";

export interface TeamStatus {
  kind: "through" | "out";
  label: string;
}

// A team's status for display. The label is always the furthest round it
// reached (R32, R16, … or "GRP" for a group-stage exit); the colour is green
// while it's still alive and grey once eliminated. Teams still in the group
// stage (not yet through, not yet out) have no badge.
export function teamStatus(t: Team): TeamStatus | null {
  const kind = t.eliminated ? "out" : "through";
  if (t.round_reached >= 1) {
    return { kind, label: ROUND_LABELS[t.round_reached as RoundReached] };
  }
  if (t.eliminated) return { kind: "out", label: "GRP" };
  return null;
}
